export const APPLICABILITY_OPTIONS = ['IN_SCOPE', 'OUT_OF_SCOPE', 'PARTIAL', 'UNKNOWN'] as const
export const IMPLEMENTATION_OPTIONS = [
  'NOT_STARTED',
  'PLANNED',
  'IMPLEMENTED',
  'PARTIAL',
  'NOT_APPLICABLE',
  'NEEDS_REVIEW',
] as const
export const EVIDENCE_RELATIONSHIP_OPTIONS = [
  'SYSTEM_EVIDENCE',
  'CONTROL_EVIDENCE',
  'AUDIT_EVIDENCE',
  'OTHER',
] as const
export const READINESS_OPTIONS = [
  'NOT_SCOPED',
  'NO_CONTROLS_MAPPED',
  'NEEDS_EVIDENCE',
  'HAS_OPEN_REMEDIATION',
  'NOT_READY',
  'READY_FOR_REVIEW',
  'UNKNOWN',
] as const
